import type { Metadata } from "next";
import AdminCampaignDiscovery from "@/Component/Admin/AdminDiscovery/CampaignDiscovery";

export const metadata: Metadata = {
    title: "Campaign Discovery | Connector Club",
    description: "",
};

const CampaignDiscoveryPage = () => {
    return (
        <AdminCampaignDiscovery />
    );
}

export default CampaignDiscoveryPage;
